import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalTemplatesComponent } from '../components/shared/modal-templates/modal-templates.component';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class ModalTemplatesService {
  private modalRef: NgbModalRef | null = null;

  constructor(
    private modalService: NgbModal,
    private languageService: LanguageService
  ) {}

  /**
   * Abre la modal de contenido legal
   */
  openLegalModal(): void {
    this.openModal('legal');
  }

  /**
   * Abre la modal de centro de ayuda
   */
  openHelpModal(): void {
    this.openModal('help');
  }

  /**
   * Cierra la modal actual
   */
  closeModal(): void {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }

  /**
   * Método privado para abrir la modal con el tipo especificado
   * @param type Tipo de modal ('legal' | 'help')
   */
  private openModal(type: 'legal' | 'help'): void {
    // Cerrar modal existente si hay una abierta
    this.closeModal();

    // Obtener idioma actual
    const currentLanguage = this.languageService.getCurrentLanguage() || 'es';

    // Abrir nueva modal
    this.modalRef = this.modalService.open(ModalTemplatesComponent, {
      size: 'fullscreen',
      scrollable: true,
      keyboard: false,
      centered: true
    });

    // Pasar datos al componente
    if (this.modalRef.componentInstance) {
      this.modalRef.componentInstance.type = type;
      this.modalRef.componentInstance.language = currentLanguage;
    }
  }

  /**
   * Verifica si hay una modal abierta
   */
  isModalOpen(): boolean {
    return this.modalRef !== null;
  }
}
